<template>
  <div class="default-page">
    <h1>Тесты</h1>
    <div class="mb-3">
      <button class="btn btn-secondary" @click="test_fillLocalDB">Заполняем локальную БД</button><br>
    </div>
    <div class="mb-3">
      <button class="btn btn-secondary" @click="test_showSpecialTestModel">Получаем данные для testModel=1002</button><br>
      <pre>TestModel: {{ testModel }}</pre>
      <pre>TestModel.field_1: {{ testModel.field_1 || 'no field 1' }}</pre>
      <pre>TestModel.virtual_field: {{ testModel.virtual_field || 'no virtual field' }}</pre>
      <pre>VirtualField: {{ testModelVirtualField || 'no virtual field' }}</pre>
    </div>
    <div class="mb-3">
      <button class="btn btn-secondary" @click="test_scanner">QR scanner</button><br>
    </div>
    <div class="mb-3">
      <div>
        <img style="border: 1px solid red; padding: 3px; border-radius: 7px;" :src="imageBase64" id="task-photo-1001" />
      </div>
      <div style="border: 1px solid red; padding: 3px; border-radius: 7px; word-break: break-all; white-space: normal; font-size: 13px; max-height: 300px; overflow-y: scroll;">
        <span style="color: #777">base64:</span><br>
        {{ imageBase64 }}
      </div>
      <button class="btn btn-secondary" @click="test_camera">Камера</button>
      или
      <button class="btn btn-secondary" @click="test_selectPhoto">Выбрать фото</button><br>
    </div>
    <div class="mb-3">
      <button class="btn btn-secondary" @click="test_openHref">Открыть ссылку в браузере</button><br>
    </div>
    <div class="mb-3">
      <button class="btn btn-secondary" @click="test_openHref2">Открыть ссылку в приложении</button><br>
    </div>

    <div class="mb-3">
      <button class="btn btn-secondary" @click="test_openHref3">Открыть ссылку в приложении без навигации</button><br>
    </div>

    <div class="mb-3">
      <button class="btn btn-secondary" @click="test_saveToDisk">Сохранить файл на диск</button><br>
    </div>
    <div class="mb-3">
      <button class="btn btn-secondary" @click="test_saveToDisk2">Сохранить файл на диск 2</button><br>
    </div>
    <div class="mb-3">
      <button class="btn btn-secondary" @click="test_saveToDisk3">Сохранить файл на диск 3</button><br>
    </div>
    <div class="mb-3">
      <button class="btn btn-secondary" @click="test_saveToDisk4">Сохранить файл на диск 4</button><br>
    </div>
    <div class="mb-3">
      <pre style="font-size: 11px;">{{ deviceData }}</pre>
      <button class="btn btn-secondary" @click="test_refreshDeviceData">Данные по устройству</button><br>
    </div>
    <div class="mb-3">
      <pre style="font-size: 11px;">{{ cordovaData }}</pre>
      <button class="btn btn-secondary" @click="test_refreshCordovaData">Распечатать cordova</button><br>
    </div>

    <div class="mb-3">
      <h3>IndexedDB</h3>
      <button class="btn btn-secondary me-1" @click="test_indexedDB_init">Init</button>
      <button class="btn btn-secondary me-1" @click="test_indexedDB_add">Add</button>
      <button class="btn btn-secondary me-1" @click="test_indexedDB_update">Update</button>
      <button class="btn btn-secondary me-1" @click="test_indexedDB_read">Read</button>
      <button class="btn btn-secondary me-1" @click="test_indexedDB_getOne">Get #1001</button>
      <br><br>
      <button class="btn btn-secondary me-1" @click="test_ModelIndexedDB">Get #1001 from Model</button>
    </div>
  </div>
</template>

<script setup>
  import { ref } from "vue";
  import { TestModel } from "@/models/TestModel";
  import idb from "@/libraries/indexedDB";
  import { TestIndexDBModel } from "@/models/TestIndexDBModel";
  import { getNow } from "@/helpers/date_time";

  const testModel = ref({});
  const testModelVirtualField = ref('');
  const cordovaData = ref([]);
  const deviceData = ref([]);
  const imageBase64 = ref('data:image/gif;base64, R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==');

  function test_fillLocalDB() {
    const tableData = [
      {
        id: 1001,
        field_1: "Test 1001",
        create_time: 1724689224
      },
      {
        id: 1002,
        field_1: "Test 1002",
        create_time: 1724689225
      },
      {
        id: 1003,
        field_1: "Test 1003",
        create_time: 1724689226
      },
      {
        id: 1004,
        field_1: "Test 1004",
        create_time: 1724689227
      },
    ];

    localStorage.setItem(
        `DB_test_table`,
        JSON.stringify( tableData )
    );

    alert('data has been filled');
  }

  function test_showSpecialTestModel() {
    try {
      const model = new TestModel(1002);
      testModel.value = model;

      testModelVirtualField.value = model.isExists()
          ? model.virtual_field
          : "TestModel#1002 doesn't exists";
    } catch (e) {
      console.log('Not found TestModel(1002) into DB', e);
    }
  }

  function test_scanner() {
    // eslint-disable-next-line
    cordova?.plugins.barcodeScanner.scan(
        result => alert('result: ' + result),
        error => alert('error: ' + error),
        {
          // preferFrontCamera : true, // iOS and Android
          // showFlipCameraButton : true, // iOS and Android
          // showTorchButton : true, // iOS and Android
          // torchOn: true, // Android, launch with the torch switched on (if available)
          // saveHistory: true, // Android, save scan history (default false)
          // prompt : "Place a barcode inside the scan area", // Android
          // resultDisplayDuration: 500, // Android, display scanned text for X ms. 0 suppresses it entirely, default 1500
          // formats : "QR_CODE,PDF_417", // default: all but PDF_417 and RSS_EXPANDED
          // orientation : "landscape", // Android only (portrait|landscape), default unset so it rotates with the device
          // disableAnimations : true, // iOS
          prompt : "Наведите на QR-код", // Android
          formats : "QR_CODE", // default: all but PDF_417 and RSS_EXPANDED
          disableSuccessBeep: false, // iOS and Android
          continuousMode: false // Android
        }
    );
  }

  function test_camera() {
    const pictureOptions = {
      cameraDirection: Camera.Direction.BACK,
      saveToPhotoAlbum: true,
      destinationType: Camera.DestinationType.DATA_URL,
      quality: 80,
    };
    navigator.camera.getPicture(
        image => {
          const img = document.getElementById(`task-photo-1001`);
          img.src = `data:image/jpeg;base64,${image}`;
          imageBase64.value = image;
        },
        () => {},
        pictureOptions
    );
  }

  function test_selectPhoto() {
    const pictureOptions = {
      cameraDirection: Camera.Direction.BACK,
      saveToPhotoAlbum: true,
      destinationType: Camera.DestinationType.DATA_URL,
      quality: 80,
      sourceType: Camera.PictureSourceType.PHOTOLIBRARY
    };
    navigator.camera.getPicture(
        image => {
          const img = document.getElementById(`task-photo-1001`);
          img.src = `data:image/jpeg;base64,${image}`;
          imageBase64.value = image;
        },
        () => {},
        pictureOptions
    );
  }

  function test_openHref() {
    const apkURL = 'https://p.kkosa.ru/get_app?secretCode=Sid1o8dXYDG17dhasigAGFOdvuaid';
    return cordova.InAppBrowser.open(apkURL, '_system', 'location=yes');
    // return cordova.InAppBrowser.open('https://abis39.ru/', '_system', 'location=yes');
  }

  function test_openHref2() {
    return cordova.InAppBrowser.open('https://abis39.ru/', '_blank', 'location=yes');
  }

  function test_openHref3() {
    return cordova.InAppBrowser.open('https://abis39.ru/', '_blank', 'location=no,toolbar=no');
  }

  function test_saveToDisk() {
    try {
      const permissions = cordova.plugins.permissions;
      const checkPermission = status => {
        const onError = () => alert('Storage permission is not turned on')

        if (status.hasPermission) {
          return
        }

        permissions.requestPermission(
            permissions.READ_EXTERNAL_STORAGE,
            status => {
              if (status.hasPermission) {
                downloadFile();
                return;
              }
              onError();
            },
            onError
        );
      }
      const apkName = `kkosa_tasks_fromTestPage.apk`;
      const apkURL = 'https://p.kkosa.ru/get_app?secretCode=Sid1o8dXYDG17dhasigAGFOdvuaid';
      const fileTransfer = new FileTransfer();
      const trustHost = true;
      const options = {};
      const downloadFile = () => {
        fileTransfer.removeRoute()
        fileTransfer.download(
            encodeURI(apkURL),
            // eslint-disable-next-line
            `${cordova.file.externalRootDirectory}download/${apkName}`,
            entry => {
              alert('success!');
              alert('Entry: ' + entry);
            },
            error => alert('FileTransfer error: ' + JSON.stringify(error)),
            trustHost,
            options
        );
      }

      downloadFile();
      // permissions.hasPermission(permissions.READ_EXTERNAL_STORAGE, checkPermission, null);
    } catch (e) {
      alert(`Common error: ${e.message}`);
    }
  }

  function test_saveToDisk2() {
    try {
      function downloadFile() {
        let filePath = cordova.file.externalRootDirectory + 'download/' + 'my_file.apk';
        let fileTransfer = new FileTransfer();
        let uri = encodeURI(decodeURIComponent(pdfPath));

        // Downloading the file
        fileTransfer.download(
            uri,
            filePath,
            function (entry) {
              alert('Successfully downloaded file, full path is ' + entry.fullPath);
              console.log(entry);
            },
            function (error) {
              alert('FT Error in download fn: ' + JSON.stringify(error));
              console.log(error);
            },
            true, // trustHost,
          {}
        );
      }
      var errorCallback = function () {
        alert('Storage permission is not turned on');
      }

      function checkPermissionCallback(status) {
        console.log('checking permissions');
        console.log(status);

        if (!status.hasPermission) {

          // Asking permission to the user
          permissions.requestPermission(
              permissions.READ_EXTERNAL_STORAGE,
              function (status) {
                if (!status.hasPermission) {
                  errorCallback();
                } else {
                  // proceed with downloading
                  try {
                    downloadFile();
                  } catch (e) {
                    alert('Download error: ' + JSON.stringify(e));
                  }
                }
              },
              errorCallback
          );
        } else {
          downloadFile();
        }
      }

      const pdfPath = 'https://p.kkosa.ru/get_app?secretCode=Sid1o8dXYDG17dhasigAGFOdvuaid';
      const permissions = cordova.plugins.permissions;
      permissions.requestPermission(permission, successCallback, errorCallback);
    } catch (e) {
      alert('saveToDisk error: ' + JSON.stringify(e));
    }
  }

  function test_saveToDisk3() {
    const permissions = cordova.plugins.permissions;

    function error(place) {
      alert('Permissions are not turned on = ' + place);
    }

    permissions.hasPermission(
        permissions.READ_EXTERNAL_STORAGE,
        function( status ){
          if ( status.hasPermission ) {
            alert("Yes :D ");
          }
          else {
            alert("No :( ");
            permissions.requestPermissions(
                permissions.READ_EXTERNAL_STORAGE,
                function(status) {
                  if( !status.hasPermission ) {
                    error('successCallback');
                  } else {
                    alert('yes we get permission :-) ');
                  }
                },
                () => {
                  error('errorCallback')
                }
            )
          }
        },
    );
  }

  function test_saveToDisk4() {
    const uri = 'https://p.kkosa.ru/get_app?secretCode=Sid1o8dXYDG17dhasigAGFOdvuaid';
    const resolve = () => {
      alert('success');
    };
    const reject = msg => {
      alert('Error: ' + msg);
    }

    cordova.plugins.safMediastore
        .readFile(uri)
        .then(arrayBuffer => {
          const blob = new Blob([new Uint8Array(arrayBuffer)], {
            type: file.type
          });
          resolve(blob);
        })
        .catch(error => {
          console.error("safMediastore Error reading file:", error, JSON.stringify(error));
          reject(error);
        });


    // const apkName = `kkosa_tasks_fromTestPage4.apk`;
    // const apkURL = 'https://p.kkosa.ru/get_app?secretCode=Sid1o8dXYDG17dhasigAGFOdvuaid';
    //
    // const ReadWriteFilesDeviceMediaStore = async (stringData, fileName) => {
    //   const base64Data = btoa(unescape(encodeURIComponent(stringData)))
    //   const result = await cordova.plugins.safMediastore.writeFile({ "data": base64Data, "filename": fileName })
    //   return result;
    // }
    //
    // ReadWriteFilesDeviceMediaStore('string for export', 'fileName.txt').
    //
    //
    // cordova.plugins.safMediastore
    //     .readFile(apkURL)
    //     .then(arrayBuffer => {
    //       const blob = new Blob([new Uint8Array(arrayBuffer)], {
    //         type: file.type
    //       });
    //       resolve(blob);
    //     })
    //     .catch(error => {
    //       console.error("safMediastore Error reading file:", error, JSON.stringify(error));
    //       reject(error);
    //     });
  }

  function test_refreshDeviceData() {
    deviceData.value = JSON.stringify(device, null, 2);
  }

  function test_refreshCordovaData() {
    cordovaData.value = JSON.stringify(cordova, null, 2);
  }

  function test_indexedDB_init() {
    idb.init();
  }

  function test_indexedDB_add() {
    idb.save('test_table', [{id: 1001, a: 1, b: 2, text: 'abc'}]);
  }

  function test_indexedDB_update() {
    idb.save('test_table', [{id: 1001, a: 1, b: 2, text: 'abc changed'}]);
  }

  async function test_indexedDB_read() {
    const data = await idb.restore('test_table');
    console.log('test_table data:', data);
  }

  async function test_indexedDB_getOne() {
    const one = await idb.findOne('test_table', 1001);
    console.log('test_table one#1001:', one);
  }

  async function test_ModelIndexedDB() {
    const m = new TestIndexDBModel(1001);
    await m.init(); // Необходимо добавлять после конструктора у IndexedDB-моделей

    // get
    console.log('data:', m.getData());
    console.log('m.a:', m.a);
    console.log('m.virtual_field:', m.virtual_field);

    // set
    m.data.temp = +getNow();
    m.text += ' super new';

    // write into DB
    m.flush();
  }
</script>